module.exports = __webpack_public_path__ + "img/161.1e4c191a.jpg";